import { render, staticRenderFns } from "./need_tome_item_box.vue?vue&type=template&id=84c1d50e"
import script from "./need_tome_item_box.vue?vue&type=script&lang=ts"
export * from "./need_tome_item_box.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports